import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient - single TanStack Query instance for all server state.
 *
 * Per the State Boundary Rule, Zustand holds ONLY ephemeral client state
 * (auth session, matchmaking queue, live game). All asynchronous REST data
 * (leaderboard, profile, replay history) flows through this client.
 *
 * Defaults:
 *  - staleTime 30s keeps the leaderboard fresh without thrashing the API
 *    on rapid screen toggles; screens override per-query where needed.
 *  - retry 1 - network blips are common on WS/REST mixed backends; a single
 *    retry is enough without masking genuine 4xx errors.
 *  - refetchOnWindowFocus off - Fog Chess is a single-page app session, not
 *    a content feed where focus refetch is desirable.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
      retryOnMount: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
